module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/gf-74219f32e778ea33b181c400c6559a6c.svg";